import { ref as d, getCurrentInstance as u, inject as I, computed as r, unref as s } from "vue";
const i = (e) => typeof e == "number", c = d(0), a = 2e3, l = Symbol("zIndexContextKey"), Z = (e) => {
  const x = e || (u() ? I(l, void 0) : void 0), n = r(() => {
    const o = s(x);
    return i(o) ? o : a;
  }), t = r(() => n.value + c.value);
  return {
    initialZIndex: n,
    currentZIndex: t,
    nextZIndex: () => (c.value++, t.value)
  };
};
export {
  a as defaultInitialZIndex,
  Z as useZIndex,
  l as zIndexContextKey
};
